import { render, staticRenderFns } from "./MobileAppOnly.vue?vue&type=template&id=e44b4e2a&"
import script from "./MobileAppOnly.vue?vue&type=script&lang=js&"
export * from "./MobileAppOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VImg,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e44b4e2a')) {
      api.createRecord('e44b4e2a', component.options)
    } else {
      api.reload('e44b4e2a', component.options)
    }
    module.hot.accept("./MobileAppOnly.vue?vue&type=template&id=e44b4e2a&", function () {
      api.rerender('e44b4e2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MobileAppOnly.vue"
export default component.exports